const PAID_MIDAS_STATUS = 'paid'
const PAID_CLIENT_STATUS = 'paid'
const MIDAS_STATUS_ORDER = [
  'awaiting documents',
  'awaiting info from the ta',
  'processing',
  'filed',
]

const CLIENT_DOCS_CLASSIFICATION_ID = 1

const CALL_TIMEOUT = 300000 // 5 Minute

///////////////////////////////
// Reclaim Dashboard Methods //
///////////////////////////////

export const getDataGroups = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let LF_DATA_URL = `${LF_API_URL}/LF/LFormData`

  let serverParameters = mapFilterToServer(filterParameters)

  $.ajax({
    method: 'POST',
    url: LF_DATA_URL,
    dataType: 'json',
    contentType: 'text/json',
    timeout: CALL_TIMEOUT,
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      successCallBack(mapVisGroupsToClient(data))
    })
    .fail(function (data) {
      failCallBack(data)
    })
}

export const getExcelData = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let LF_DATA_URL = `${LF_API_URL}/LF/LFormTransExcel`
  let serverParameters = mapFilterToServer(filterParameters)

  $.ajax({
    method: 'POST',
    url: LF_DATA_URL,
    dataType: 'json',
    contentType: 'text/json',
    timeout: CALL_TIMEOUT,
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      successCallBack(data)
    })
    .fail(function (data) {
      failCallBack(data)
    })
}

export const GetReclaimDashboardPdf = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let LF_DATA_URL = `${LF_API_URL}/LF/ReclaimDashboardPDF`
  let serverParameters = mapFilterToServer(filterParameters)

  $.ajax({
    method: 'POST',
    url: LF_DATA_URL,
    dataType: 'json',
    contentType: 'text/json',
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      successCallBack(data, '')
    })
    .fail(function (data) {
      failCallBack(data)
    })
}

//////////////////////////////
// Quarterly Report Methods //
//////////////////////////////

export const getAvailableQuarterlyReports = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let QS_DATA_URL = `${LF_API_URL}/QR/AvailableReports`
  let serverParameters = mapStatementsFilterToServer(filterParameters)

  $.ajax({
    method: 'POST',
    url: QS_DATA_URL,
    dataType: 'json',
    contentType: 'text/json',
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      var clientData = mapQuarterlyStatementsToClient(data)
      successCallBack(clientData)
    })
    .fail(function (data) {
      failCallBack(data)
    })
}

export const downloadQuarterlyReport = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let QS_DATA_URL = `${LF_API_URL}/QR/ExcelReport`
  let serverParameters = mapStatementsFilterToServer(filterParameters)

  $.ajax({
    method: 'POST',
    url: QS_DATA_URL,
    dataType: 'json',
    contentType: 'text/json',
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      successCallBack(data)
    })
    .fail(function (data) {
      failCallBack(data)
    })
}
///////////////////////////////
// Payment Statement Methods //
///////////////////////////////

export const getAvailablePaymentStatements = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let QS_DATA_URL = `${LF_API_URL}/PS/AvailableStatements`
  let serverParameters = mapStatementsFilterToServer(filterParameters)

  $.ajax({
    method: 'POST',
    url: QS_DATA_URL,
    dataType: 'json',
    contentType: 'text/json',
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      var clientData = mapPaymentStatementsToClient(data)
      successCallBack(clientData)
    })
    .fail(function (data) {
      failCallBack(data)
    })
}

export const downloadPaymentStatement = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let QS_DATA_URL = `${LF_API_URL}/PS/ExcelStatement`
  let serverParameters = mapStatementsFilterToServer(filterParameters)

  $.ajax({
    method: 'POST',
    url: QS_DATA_URL,
    dataType: 'json',
    contentType: 'text/json',
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      successCallBack(data)
    })
    .fail(function (data) {
      failCallBack(data)
    })
}

/////////////////////////////////
// Document Management Methods //
/////////////////////////////////

export const getDocumentAccounts = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let DM_ACCT_URL = `${LF_API_URL}/DM/Accounts`
  let serverParameters = mapDocManagementFilterToServer(filterParameters)

  $.ajax({
    method: 'POST',
    url: DM_ACCT_URL,
    dataType: 'json',
    contentType: 'text/json',
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      data.netMidasStatusSum = mapClientStatusSumToClient(
        data.netMidasStatusSum,
      )
      data.coiNetReclaimSum = mapCountryStatusSumToClient(data.coiNetReclaimSum)
      data.fiAcctTransactionSum = mapFiAcctToClient(data.fiAcctTransactionSum)
      successCallBack(data, '')
    })
    .fail(function (data) {
      failCallBack(data)
    })
}

export const getDocuments = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let DM_ACCT_URL = `${LF_API_URL}/DM/Documents`
  let serverParameters = mapDocManagementFilterToServer(filterParameters)

  $.ajax({
    method: 'POST',
    url: DM_ACCT_URL,
    dataType: 'json',
    contentType: 'text/json',
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      successCallBack(data, '')
    })
    .fail(function (data) {
      failCallBack(data)
    })
}

export const downloadDocumentExcel = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let DM_EXPORT_URL = `${LF_API_URL}/DM/Export`
  let serverParameters = mapDocManagementFilterToServer(filterParameters)
  serverParameters.report_type = 'documents'

  $.ajax({
    method: 'POST',
    url: DM_EXPORT_URL,
    dataType: 'json',
    contentType: 'text/json',
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      successCallBack(data, '')
    })
    .fail(function (data) {
      failCallBack(data)
    })
}

export const downloadItemExcel = function (
  filterParameters,
  successCallBack,
  failCallBack,
) {
  let DM_EXPORT_URL = `${LF_API_URL}/DM/Export`
  let serverParameters = mapDocManagementFilterToServer(filterParameters)
  serverParameters.report_type = 'items'

  $.ajax({
    method: 'POST',
    url: DM_EXPORT_URL,
    dataType: 'json',
    contentType: 'text/json',
    data: JSON.stringify(serverParameters),
  })
    .done(function (data) {
      successCallBack(data, '')
    })
    .fail(function (data) {
      failCallBack(data)
    })
}

function mapDocManagementFilterToServer(filterParameters) {
  var serverFilters = {}

  serverFilters['view_as_user_id'] = filterParameters.viewAsUserId
  serverFilters['fi_code'] = filterParameters.custodian
  serverFilters['acct_code'] = filterParameters.accountNumber
  serverFilters['coi'] = filterParameters.coi
  serverFilters['client_status'] = filterParameters.clientFacingStatus
  serverFilters['boclient_id'] = filterParameters.boClientId
  serverFilters['fund_boclient_id'] = filterParameters.fundBOClientId
  serverFilters['group_by'] = filterParameters.groupBy
  // serverFilters['accounts'] = filterParameters.fiAccts.map((acct) => ({
  //   fi_code: acct.fiCode,
  //   acct_code: acct.acctCode,
  // }))

  if (filterParameters.clientDocsOnly)
    serverFilters['classification_id'] = CLIENT_DOCS_CLASSIFICATION_ID

  return serverFilters
}

export function mapPaymentStatementsToClient(paymentStatements) {
  if (paymentStatements == null) return null

  return paymentStatements.map((p) => {
    return {
      id: p.report_id,
      reportGuid: p.report_guid,
      statementName: p.statement_name,
      statementAmt: p.statement_pay_amount,
      statementDate: p.statement_date,
    }
  })
}

export function mapQuarterlyStatementsToClient(quarterlyStatements) {
  if (quarterlyStatements == null) return null

  return quarterlyStatements.map((q) => {
    return {
      id: q.report_id,
      reportGuid: q.report_guid,
      statementName: q.statement_name,
      statementDate: q.statement_date,
    }
  })
}

export function mapClientStatusSumToClient(serverClientStatusSum) {
  var clientStatusSum = serverClientStatusSum.map((g) => {
    return {
      netReclaim: g.net_reclaim_usd,
      transCount: g.transactionCount,
      acctCount: g.acctCount,
      status: g.client_facing_status,
    }
  })

  clientStatusSum = getPercentagesForGroup('netReclaim', clientStatusSum)

  return clientStatusSum
}

export function mapCountryStatusSumToClient(serverCountryStatusSum) {
  let countryStatusSum = serverCountryStatusSum.map((g) => {
    return {
      netReclaim: g.net_reclaim_usd,
      transCount: g.transactionCount,
      acctCount: g.acctCount,
      coiName: g.coi_name.trim(),
    }
  })

  countryStatusSum = getPercentagesForGroup('netReclaim', countryStatusSum)

  return countryStatusSum
}

export function mapFiAcctToClient(serverFiAcctSum) {
  let clientFiAcctSum = serverFiAcctSum.map((g) => {
    return {
      fiName: g.fi_name.trim(),
      fiCode: g.fi_code.trim(),
      acctCode: g.acct_code.trim(),
      boName: g.bo_name.trim(),
      netReclaim: g.net_reclaim_usd,
      transCount: g.transactionCount,
    }
  })

  return clientFiAcctSum
}

export function mapVisGroupsToClient(serverVisGroups) {
  let clientVisGroups = {}

  if (serverVisGroups == null) return null

  clientVisGroups['summaryStats'] = {
    totalProcessing: serverVisGroups['total_processing'],
    totalFiled: serverVisGroups['total_filed'],
    paidSinceIncp: serverVisGroups['total_paid'],
    paidYTD: serverVisGroups['total_paid_year_date'],
    numActiveAcct: serverVisGroups['total_active_acct'],
    numActiveTrans: serverVisGroups['total_active_transaction'],
    numPaidAcct: serverVisGroups['total_number_paid_account'],
    numPaidTrans: serverVisGroups['total_number_paid_transaction'],
    numEvents: serverVisGroups['total_event_count'],
  }

  clientVisGroups['midasStatGroups'] = serverVisGroups.netMidasStatusSum
    .map((g) => {
      return {
        netReclaim: g.net_reclaim_usd,
        transCount: g.transactionCount,
        acctCount: g.acctCount,
        status: g.midas_cat,
      }
    })
    .filter((g) => g.status.toLowerCase() != PAID_MIDAS_STATUS) // the paid group is not used
    .sort(
      (a, b) =>
        MIDAS_STATUS_ORDER.indexOf(b.status.toLowerCase()) -
        MIDAS_STATUS_ORDER.indexOf(a.status.toLowerCase()),
    )
  clientVisGroups['clientFacingStatGroups'] =
    serverVisGroups.netReclaimClientStatusSum
      .filter((g) => g.client_facing_status.toLowerCase() != PAID_CLIENT_STATUS)
      .map((g) => {
        return {
          netReclaim: g.net_reclaim_usd,
          transCount: g.transactionCount,
          acctCount: g.acctCount,
          status: g.client_facing_status,
        }
      })

  clientVisGroups['clientFacingStatGroups'] = getPercentagesForGroup(
    'netReclaim',
    clientVisGroups['clientFacingStatGroups'],
  )

  clientVisGroups['yearGroups'] = serverVisGroups.yearNetReclaimSum
    .map((g) => {
      return {
        netReclaim: g.net_reclaim_usd,
        transCount: g.transactionCount,
        acctCount: g.acctCount,
        yearPaid: g.year_paid,
      }
    })
    .sort((a, b) => a.yearPaid - b.yearPaid)

  clientVisGroups['countryGroups'] = serverVisGroups.coiNetReclaimSum.map(
    (g) => {
      return {
        netReclaim: g.net_reclaim_usd,
        transCount: g.transactionCount,
        acctCount: g.acctCount,
        coiName: g.coi_name.trim(),
      }
    },
  )

  clientVisGroups['countryGroups'] = getPercentagesForGroup(
    'netReclaim',
    clientVisGroups['countryGroups'],
  )

  clientVisGroups['fiAcctGroups'] = serverVisGroups.fiAcctTransactionSum.map(
    (g) => {
      return {
        fiName: g.fi_name.trim(),
        fiCode: g.fi_code.trim(),
        acctCode: g.acct_code.trim(),
        boName: g.bo_name.trim(),
        netReclaim: g.net_reclaim_usd,
        transCount: g.transactionCount,
      }
    },
  )

  return clientVisGroups
}

// Method converts the client side filters to server side request object
export function mapFilterToServer(clientFilters) {
  let serverFilters = {}
  serverFilters['filter'] = true
  serverFilters['trans_Type'] = clientFilters.transType
  serverFilters['midas_Status'] = clientFilters.midasStatuses.join()
  serverFilters['client_Facing_Status'] =
    clientFilters.clientFacingStatuses.join()
  serverFilters['coi'] = clientFilters.countryNames.join()
  serverFilters['fI_Code'] = clientFilters.fiCodes.join()
  serverFilters['acct_Code'] = clientFilters.acctCodes.join()
  serverFilters['payrcvd_Year'] = clientFilters.yearsPaid.join()

  // This value allows admin users to alter the userId
  // to emulate different clients
  serverFilters['view_as_user_id'] = clientFilters.viewAsUserId

  // The server accepts these values but they are not in use
  serverFilters['bO_ClientID'] = ''
  serverFilters['group_Code'] = ''

  // Pass Investor_Breakdown if present
  if (typeof clientFilters.Investor_Breakdown !== 'undefined') {
    serverFilters['Investor_Breakdown'] = clientFilters.Investor_Breakdown
  }

  return serverFilters
}

export function mapStatementsFilterToServer(clientFilters) {
  let serverFilters = {}

  serverFilters['report_id'] = null
  serverFilters['report_guid'] = clientFilters.reportGuid

  // This value allows admin users to alter the userId
  // to emulate different clients
  serverFilters['view_as_user_id'] = clientFilters.viewAsUserId

  return serverFilters
}

const getPercentagesForGroup = function (fieldName, groups) {
  let total = 0
  groups.forEach((g) => (total += g[fieldName]))
  return groups.map((g) => {
    return {
      ...g,
      pct: g[fieldName] / total,
    }
  })
}
